import { render, staticRenderFns } from "./shphdentist.vue?vue&type=template&id=50687888&scoped=true&"
import script from "./shphdentist.vue?vue&type=script&lang=js&"
export * from "./shphdentist.vue?vue&type=script&lang=js&"
import style0 from "./shphdentist.vue?vue&type=style&index=0&id=50687888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50687888",
  null
  
)

export default component.exports